import { ReceiverTypes } from '@betterplace/api-graphql-types'
import { numericString } from '@/schema'
import { z } from 'zod'

export const createMultipleDonationsFormSchema = z.object({
  receiverId: numericString,
  receiverType: z.nativeEnum(ReceiverTypes),
  number: z.number().min(1),
})

export type CreateMultipleDonationsFormValues = z.infer<typeof createMultipleDonationsFormSchema>
